const path = require('path')

const router = require('../../router')


module.exports = async(graphql, actions, route) => {
  const { createPage } = actions
  const videoContainer = path.resolve('src/containers/Video/index.js')

  return createPage({
    path: router(route.path),
    component: videoContainer,
    context: {},
  })
}
